import { Box, Heading, Paragraph, Image, Section } from '@alto-avios/alto-ui'
import {
  ContentfulEducationalComponent as ContentfulEducationalComponentProps,
  getTextAlignment,
} from '@reward-platform/contentful'
import styles from './ContentfulEducationalComponent.module.scss'

const ContentfulEducationalComponent = ({
  heading,
  headingAlignment,
  items,
}: ContentfulEducationalComponentProps) => {
  // Always make sure we are displaying either 2 or 4 blocks
  const MAX_BLOCKS = items?.length === 4 ? 4 : 2

  return (
    <Section
      containerMaxWidth="page"
      paddingX="default"
      paddingY="default"
      flexDirection="row"
      justifyContent="center"
      alignItems="start"
    >
      <Section.Container>
        <Box
          backgroundColor="layer1"
          borderRadius="xs"
          gap="sm"
          flexDirection="column"
          alignItems="center"
          width="full"
          className={styles.container}
        >
          <Heading
            as="h2"
            size="md"
            foregroundColor="accentSecondary"
            textAlign={getTextAlignment(headingAlignment)}
          >
            {heading}
          </Heading>
          <Box gap="sm" width="full" className={styles.itemsContainer}>
            {items?.slice(0, MAX_BLOCKS).map((item, index) => (
              <Box
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                backgroundColor="layer2"
                borderWidth="sm"
                borderRadius="xs"
                borderColour="secondary"
                borderStyle="solid"
                padding="xs"
                gap="xs"
                alignItems="center"
                justifyContent="start"
              >
                {item.icon ? (
                  <Image
                    src={item.icon.file?.url}
                    alt={item.icon.file?.fileName}
                    borderRadius="0"
                  />
                ) : null}
                <Paragraph
                  size="md"
                  foregroundColor="accentSecondary"
                  textAlign={getTextAlignment(item.textAlignment)}
                >
                  {item.text}
                </Paragraph>
              </Box>
            ))}
          </Box>
        </Box>
      </Section.Container>
    </Section>
  )
}

export default ContentfulEducationalComponent
